// @flow
export const filterId: 'student' = 'student';
